import React from 'react';
import { motion } from 'framer-motion';

const Button = ({ children, variant = 'primary', className = '', ...props }) => {
  const baseStyles = "relative inline-flex items-center justify-center px-6 py-2.5 rounded-full font-medium transition-all duration-300 overflow-hidden";
  
  const variants = {
    primary: "bg-gradient-to-r from-orange-600 to-yellow-500 text-white shadow-[0_0_20px_rgba(234,88,12,0.2)] hover:shadow-[0_0_30px_rgba(234,88,12,0.5)] border border-orange-400/50 hover:-translate-y-0.5",
    secondary: "bg-zinc-900/80 backdrop-blur-md text-amber-100 border border-orange-500/20 hover:border-orange-500/50 hover:bg-zinc-800/80",
    ghost: "text-zinc-400 hover:text-amber-100 hover:bg-white/5"
  };

  return (
    <motion.button 
      whileTap={{ scale: 0.98 }}
      className={`${baseStyles} ${variants[variant]} ${className}`}
      {...props}
    >
      <span className="relative z-10 flex items-center gap-2">{children}</span>
    </motion.button>
  );
};

export default Button;